module.exports = __webpack_public_path__ + "img/6.eeb7e1ed.svg";